class TabsContainer extends HTMLElement {
  constructor() {
    super();
    this.tabs = null;
    this.panel = null;
    this.cachedContents = new Map();
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-ref="tab"]');
    this.panel = this.querySelector('[data-ref="tabs-panel"]');

    this.tabs.forEach((tab) => {
      const template = tab.querySelector('template');
      const content = template.content.querySelector('[data-ref="tab-content"]');
      const node = document.importNode(content, true);
      this.cachedContents.set(tab, node);

      tab.addEventListener('click', () => {
        this.#resetTabs();
        this.#selectTab(tab);
      });
    });

    this.#selectTab(this.tabs[0]);
  }

  #selectTab(tab) {
    const node = this.cachedContents.get(tab);
    this.panel.appendChild(node);
    tab.classList.add('active');
  }

  #resetTabs() {
    this.tabs.forEach((tab) => {
      tab.classList.remove('active');
    });
    while (this.panel.firstChild) {
      const child = this.panel.firstChild;
      const entry = [...this.cachedContents.entries()].find(([, n]) => n === child);
      if (entry) this.cachedContents.set(entry[0], this.panel.removeChild(child));
      else this.panel.removeChild(child);
    }
  }
}

if (!customElements.get('tabs-container')) {
  customElements.define('tabs-container', TabsContainer);
}
